export enum DatasourceType {
  PRODUCT_CATALOG = 'product_catalog',
  SNOWFLAKE = 'snowflake',
  DATADOG = 'datadog',
  BLOOMBERG = 'bloomberg',
  REUTERS = 'reuters',
  DATABASE = 'database',
  API = 'api',
  FILE_SYSTEM = 'file_system',
  STREAMING = 'streaming',
  CUSTOM = 'custom',
}

export enum ConnectionStatus {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  ERROR = 'error',
  PENDING = 'pending',
}

export interface DatasourceConfig {
  host?: string
  port?: number
  database?: string
  username?: string
  apiKey?: string
  endpoint?: string
  region?: string
  bucket?: string
  topic?: string
  [key: string]: any
}

export interface Datasource {
  id: string
  name: string
  type: DatasourceType
  description: string
  provider?: string
  connectionStatus: ConnectionStatus
  lastConnected?: string
  createdAt: string
  updatedAt: string
  config?: DatasourceConfig
  metadata?: {
    dataFrequency?: string
    dataFormat?: string
    dataVolume?: string
    latency?: string
    reliability?: string
    [key: string]: any
  }
  tags?: string[]
  // If it's a product from catalog
  productId?: string
  productName?: string
  // Usage statistics
  usageStats?: {
    totalQueries: number
    lastQueried?: string
    avgResponseTime?: number
    errorRate?: number
  }
}

export interface DatasourceListResponse {
  datasources: Datasource[]
  total: number
  page: number
  limit: number
  hasMore: boolean
}

export interface DatasourceFilters {
  type?: DatasourceType
  status?: ConnectionStatus
  search?: string
  tags?: string[]
}
